<template>
  <div class="about">
    <div clas="container-fluid">
      <div class="row">
        <div class="col-8 offset-2">
          <modal id="myModal" @cancelClicked="cancel()" @okClicked="ok()"
            >Just a test message</modal
          >
          <h1>This is an about page</h1>
          <div class="kt-portlet">
            <div class="kt-portlet__head kt-portlet__head--noborder">
              <div class="kt-portlet__head-label">
                <h3 class="kt-portlet__head-title">Author Sales</h3>
              </div>
              <div class="kt-portlet__head-toolbar">
                <div class="kt-portlet__head-toolbar-wrapper">
                  <div class="dropdown dropdown-inline">
                    <button
                      type="button"
                      class="btn btn-clean btn-sm btn-icon btn-icon-md"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="flaticon-more-1"></i>
                    </button>
                    <div class="dropdown-menu dropdown-menu-right">
                      <ul class="kt-nav">
                        <li class="kt-nav__section kt-nav__section--first">
                          <span class="kt-nav__section-text">Export Tools</span>
                        </li>
                        <li class="kt-nav__item">
                          <a href="#" class="kt-nav__link">
                            <i class="kt-nav__link-icon la la-print"></i>
                            <span class="kt-nav__link-text">Print</span>
                          </a>
                        </li>
                        <li class="kt-nav__item">
                          <a href="#" class="kt-nav__link">
                            <i class="kt-nav__link-icon la la-copy"></i>
                            <span class="kt-nav__link-text">Copy</span>
                          </a>
                        </li>
                        <li class="kt-nav__item">
                          <a href="#" class="kt-nav__link">
                            <i class="kt-nav__link-icon la la-file-excel-o"></i>
                            <span class="kt-nav__link-text">Excel</span>
                          </a>
                        </li>
                        <li class="kt-nav__item">
                          <a href="#" class="kt-nav__link">
                            <i class="kt-nav__link-icon la la-file-text-o"></i>
                            <span class="kt-nav__link-text">CSV</span>
                          </a>
                        </li>
                        <li class="kt-nav__item">
                          <a href="#" class="kt-nav__link">
                            <i class="kt-nav__link-icon la la-file-pdf-o"></i>
                            <span class="kt-nav__link-text">PDF</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="kt-portlet__body kt-portlet__body--fluid">
              <div class="kt-widget-19">
                <div class="kt-widget-19__title">
                  <div class="kt-widget-19__label"><small>$</small>64M</div>
                  <img
                    class="kt-widget-19__bg"
                    src="/assets/media/misc/iconbox_bg.png"
                    alt="bg"
                  />
                </div>
                <div class="kt-widget-19__data">
                  <!--Doc: For the chart bars you can use state helper classes: kt-bg-success, kt-bg-info, kt-bg-danger. Refer: components/custom/colors.html -->
                  <div class="kt-widget-19__chart">
                    <div class="kt-widget-19__bar">
                      <div
                        class="kt-widget-19__bar-45"
                        data-toggle="kt-tooltip"
                        data-skin="brand"
                        data-placement="top"
                        title=""
                        data-original-title="45"
                      ></div>
                    </div>
                    <div class="kt-widget-19__bar">
                      <div
                        class="kt-widget-19__bar-95"
                        data-toggle="kt-tooltip"
                        data-skin="brand"
                        data-placement="top"
                        title=""
                        data-original-title="95"
                      ></div>
                    </div>
                    <div class="kt-widget-19__bar">
                      <div
                        class="kt-widget-19__bar-63"
                        data-toggle="kt-tooltip"
                        data-skin="brand"
                        data-placement="top"
                        title=""
                        data-original-title="63"
                      ></div>
                    </div>
                    <div class="kt-widget-19__bar">
                      <div
                        class="kt-widget-19__bar-11"
                        data-toggle="kt-tooltip"
                        data-skin="brand"
                        data-placement="top"
                        title=""
                        data-original-title="11"
                      ></div>
                    </div>
                    <div class="kt-widget-19__bar">
                      <div
                        class="kt-widget-19__bar-46"
                        data-toggle="kt-tooltip"
                        data-skin="brand"
                        data-placement="top"
                        title=""
                        data-original-title="46"
                      ></div>
                    </div>
                    <div class="kt-widget-19__bar">
                      <div
                        class="kt-widget-19__bar-88"
                        data-toggle="kt-tooltip"
                        data-skin="brand"
                        data-placement="top"
                        title=""
                        data-original-title="88"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import RestHelper from '../common/rest-helper';
import toastr from '../common/toastr-util';
import { mixins } from '../mixins/mixins';
import Modal from '../components/Modal.vue';

export default {
  name: 'about',
  components: { Modal },
  methods: {
    cancel() {
      alert('cancelled');
    },
    ok() {
      alert('oked');
    }
  },
  mixins: [mixins]
};
</script>
